import React, { useCallback, useMemo, useState } from 'react';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import { Button } from 'devextreme-react';
import { formatMessage } from 'devextreme/localization';
import { LoadPanel } from 'devextreme-react/load-panel';
import ProgressBar from 'devextreme-react/progress-bar';
import Header from '../../components/Header';
import style from './layout.module.scss';
import SupportForm from '../../routes/Support';
import PopupMVP from '../../components/PopupMVP';
import SupportChat from '../../components/SupportChat/SupportChat';

const Layout = ({
  settingsLoadingReducer: {
    counter,
    visibleProgressBar,
    countProgressBar,
    countSK
  },
  userReducer: {
    corporate
  },
  children,
  onMenuToggle,
  openSupportWindow,
  shippingType
}) => {
  const [supportChatVisible, setSupportChatVisible] = useState(false);
  const textFooterBefore = useMemo(
    () => () => {
      const year = new Date().getFullYear();
      return (
        <span>
          {formatMessage('textFooterLeftStart')}
          {year}
          {formatMessage('textFooterLeftFinish')}
        </span>
      );
    },
    []
  );

  const openSupportCorporate = useCallback(() => {
    const newWindow = window.open('https://wd-solman.severstal.severstalgroup.com:7000/SAP/BC/UI5_UI5/SAP/ZSMI019_CRE_INC/INDEX.HTML?#/Request?PROCESS_TYPE=ZMIN&COMP=RS&SelectedBukrs=3500&SID=MES', '_blank');
    newWindow.opener = null;
  }, []);

  const help = useMemo(
    () => () => (
      <Button
          className={style.errorButton}
          stylingMode={'text'}
          icon="email"
          text={formatMessage('textFooterRight')}
          // onClick={() => setSupportChatVisible((prev) => !prev)}
          onClick={corporate ? openSupportCorporate : openSupportWindow}
        />
    ), [corporate, openSupportCorporate, openSupportWindow]
  );

  const renderLoading = useMemo(() => (
    <LoadPanel shadingColor={'rgba(0,0,0,0.8)'}
               position={{ of: '#root' }}
               showIndicator
               shading
               showPane
               closeOnOutsideClick={false}
               visible={counter > 0}
    />
  ), [counter]);

  const statusFormat = useCallback(() => (
    `Загружено СК (${countProgressBar}/${countSK})`
  ), [countProgressBar, countSK]);

  const renderProgressBar = useMemo(() => (
    <PopupMVP
      visible={visibleProgressBar > 0}
      showTitle={false}
    >
      <ProgressBar
        min={0}
        max={countSK}
        value={countProgressBar}
        statusFormat={statusFormat}
      />
    </PopupMVP>
  ), [visibleProgressBar, countProgressBar, statusFormat, countSK]);

  return (
    <div className={style.containing}>
      <div className={style.containingHeader}>
        <Header onMenuToggle={onMenuToggle} shippingType={shippingType} />
      </div>
      <div className={style.containingMain} id="main-content">
        {children}
      </div>
      <div className={style.containingFooter}>
        <SupportChat visible={supportChatVisible} setVisible={setSupportChatVisible}/>
        <Toolbar elementAttr={{ class: style.toolbar }}>
          <Item location={'before'} render={textFooterBefore} />
          <Item location={'after'} render={help} cssClass={style.helpButton} />
        </Toolbar>
      </div>
      { renderLoading }
      { renderProgressBar }
      <SupportForm />
    </div>
  );
};

export default React.memo(Layout);
